export const NewsRoute: Path = '/news'

export const SolitaireHorizontalMoveRoute: Path = `${NewsRoute}/solitaire-horizontal-move`

export const SolitaireMovesCardsRoute: Path = `${NewsRoute}/solitaire-moves-cards`

export const SolitaireTermsExplainedRoute: Path = `${NewsRoute}/solitaire-terms-explained`

export const SolitaireUndoTrickRoute: Path = `${NewsRoute}/solitaire-undo-trick`
